let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fj2Yv")).then(() => parcelRequire('3i1po'));